import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/views/Main';
import Login from '@/views/Login';
import EmployeeList from '@/components/EmployeeList';
import EditEmployee from '@/components/EditEmployee';
import EmployeeInfo from '@/components/EmployeeInfo';
import OrderList from '@/components/OrderList';
import Order from '@/components/Order';
import Admin from '@/components/Admin';
import EditAdmin from '@/components/EditAdmin';
import AdminInfo from '@/components/AdminInfo';
import Authorization from '@/components/Authorization';
import CooperationTeam from '@/components/CooperationTeam'
import EditCooperationTeam from '@/components/EditCooperationTeam'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: 'employeelist',
          name: 'EmployeeList',
          component: EmployeeList
        },
        {
          path: 'editemployee',
          name: 'EditEmployee',
          component: EditEmployee
        },
        {
          path: 'employeeinfo/:id',
          name: 'EmployeeInfo',
          component: EmployeeInfo
        },
        {
          path: 'orderlist',
          name: 'OrderList',
          component: OrderList,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'order/:orderId',
          name: 'Order',
          component: Order
        },
        {
          path: 'admin',
          name: 'Admin',
          component: Admin
        },
        {
          path: 'editAdmin',
          name: 'EditAdmin',
          component: EditAdmin
        },
        {
          path: 'adminInfo',
          name: 'AdminInfo',
          component: AdminInfo
        },
        {
          path: 'authorization',
          name: 'Authorization',
          component: Authorization
        },
        {
          path: 'cooperationTeam',
          name: 'CooperationTeam',
          component: CooperationTeam
        },
        {
          path: 'editCooperationTeam',
          name: 'EditCooperationTeam',
          component: EditCooperationTeam
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js